import React from 'react'
import { Button, Card, Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as BrainImage } from 'static/svg/brain.svg'

import * as S from './styles'

type NextScheduleCTAProps = {
  onClick: () => void
}

export const NextScheduleCTA = ({ onClick }: NextScheduleCTAProps) => {
  return (
    <Card
      customClassName='PatientHome__Card'
      variant='regular'
    >
      <S.Container>
        <BrainImage />
        <S.BrainShadow />

        <Typography variant='content2' center>
          Você não agendou sua consulta. <br/> Não deixe sua saúde mental sem cuidados.
        </Typography>

        <Button
          variant='text'
          uppercase={false}
          onClick={onClick}
        >
          Marcar consulta
        </Button>
      </S.Container>
    </Card>
  )
}